<div class="h-full w-full flex flex-col justify-start overflow-hidden space-y-4">
  <app-admin-options-nav />

  <!-- Main Tabbed Section -->
  <div class="h-full min-h-0 flex-1 flex flex-col w-full overflow-hidden">
    @switch (selectedTab()) {
    @case ('payouts') {
    <admin-payouts></admin-payouts>
    }
    @case ('tax') {
    <admin-tax></admin-tax>
    }
    @case ('moderate') {
    <admin-moderate></admin-moderate>
    }
    @case ('faq') {
    <admin-faq></admin-faq>
    }
    @case ('inspired') {
    <admin-inspired></admin-inspired>
    }
    @default {
    <admin-payouts></admin-payouts>
    }
    }
  </div>
  <!-- Main Tabbed Section - END -->
</div>
